<template>
    <div class="content-height-full">
        <prospect-map
            style="width: 100%; height: 100%;"
            :prospects="[]"
            :can-draw="true"
            @boundsChanged="fetchAddressesWithinViewport"
        >
            <gmap-cluster>
                <gmap-marker
                    v-for="(marker, index) in addresses"
                    :key="index"
                    :icon="localMarkerIcon(marker)"
                    :position="markerPosition(marker)"
                    :clickable="true"
                    :draggable="false"
                />
            </gmap-cluster>
        </prospect-map>

        <div v-if="wontShowAddresses" class="text-lg absolute pin-l pin-b p-xl bg-accent-clay-orange-dark text-white m-lg">
            Adresser kommer inte synas innan du zoomat in djupare på kartan.
        </div>
        <div v-else-if="loading" class="text-lg absolute pin-l pin-b p-xl bg-accent-clay-orange-dark text-white m-lg">
            <font-awesome-icon icon="spinner" spin />
            Laddar adresser
        </div>
    </div>
</template>
<script>
    import AddressesInViewport from './AddressesInViewport';
    import BasicMapFunctionality from '../../../shared/components/Maps/BasicMapFunctionality.js';
    import { markerIcon } from '../../../shared/mixins/MapMarkerIcon';

    export default {
        extends: AddressesInViewport,
        mixins: [BasicMapFunctionality],
        data() {
            return {
                addresses: [],
            };
        },
        created() {
            EventBus.$on(
                'shape-drawn',
                (options, shape) => this.createProject(options, shape),
            );
        },
        methods: {
            localMarkerIcon(marker) {
                return markerIcon(marker, this.getSalesCustomMapMarkerIcon(marker));
            },
            markerPosition(marker) {
                return {
                    lat: parseFloat(marker.lat),
                    lng: parseFloat(marker.lng),
                };
            },
            createProject(coordinates, shape) {
                this.$modal.show('create-delivery-project-modal', { coordinates: coordinates });
            },
        },
    };
</script>